import React, {useEffect, useState} from "react";
import {Header} from "../../components/structure/Header";
import {Grid, MenuItem, Select} from "@mui/material";
import {SEText} from "../../components/SEText";
import AnotacaoOrientacao from "./AnotacaoOrientacao";
import {useHistory} from "react-router-dom";
import {SelectChangeEvent} from "@mui/material/Select";
import {styled} from "@mui/material/styles";
import {RiArrowDropDownLine} from "react-icons/ri";
import ArquivosAnexos from "./ArquivosAnexos";
import {useLocation} from "react-router";
import useRenderFormStore from "./stores/useRenderFormStore";
import TiposRegistro from "./TiposRegistro";
import AgentesSSE from "./AgentesSSE";
import DevolutivaPadrao from "./DevolutivaPadrao";
import ErrosEnvioSas from "./ErrosEnvioSas";
import VersionamentoApp from "./VersionamentoApp";
import ManutencaoApp from "./ManutencaoApp";
import AtendimentoRecusado from "./AtendimentoRecusado";
import SolucoesSebrae from "./SolucoesSebrae";
import CanaisDigitais from "./CanaisDigitais";
import BlacklistSSE from "./BlacklistSSE";
import RegrasContabilizacao from "./RegrasContabilizacao";
import SolicitacaoDeVinculo from "./SolicitacaoDeVinculo";
import EditarAtendimento from "./EditarAtendimento";
import HabilitarDiagnostico from "./HabilitarDiagnostico";
import ProjetosAcoes from "./ProjetosAcoes";
import {hasAdminRole, hasGestorSSERole} from "../../../utils/hasPermission";

const CustomSelect = styled(Select)({
  backgroundColor: "#7B80FF",
  fontFamily: "Mulish, sans-serif",
  fontWeight: "bold",
  fontSize: 16,
  color: "white",
  "& .MuiSelect-icon": {
    color: "white",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#7B80FF",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "white",
  },
});

interface MenuOption {
  id: string;
  label: string;
  component: JSX.Element;
  allowAccessGestorSSE: boolean;
}

const ControlTables = () => {
  const history = useHistory();
  const location = useLocation();

  const menuOptions: MenuOption[] = [
    {
      id: "tipos-registros",
      label: "Atendimentos: tipos de registro",
      component: <TiposRegistro />,
      allowAccessGestorSSE: false,
    },
    {
      id: "canais-digitais",
      label: "Atendimentos: canais digitais",
      component: <CanaisDigitais />,
      allowAccessGestorSSE: true,
    },
    {
      id: "regras-contabilizacao",
      label: "Atendimentos: regras de contabilização",
      component: <RegrasContabilizacao />,
      allowAccessGestorSSE: false,
    },
    {
      id: "solucoes-sebrae",
      label: "Atendimentos: soluções Sebrae",
      component: <SolucoesSebrae />,
      allowAccessGestorSSE: true,
    },
    {
      id: "agentes-consultores",
      label: "Atendimentos: agentes e consultores",
      component: <AgentesSSE />,
      allowAccessGestorSSE: true,
    },
    {
      id: "cnpj-recusou",
      label: "Atendimentos: CNPJ recusou",
      component: <AtendimentoRecusado />,
      allowAccessGestorSSE: true,
    },
    {
      id: "editar-atendimento",
      label: "Atendimentos: edição de registros",
      component: <EditarAtendimento />,
      allowAccessGestorSSE: true,
    },
    {
      id: "devolutiva-padrao",
      label: "Diagnóstico: devolutiva padrão",
      component: <DevolutivaPadrao />,
      allowAccessGestorSSE: false,
    },
    {
      id: "habilitar-no-app",
      label: "Diagnóstico: habilitar no App",
      component: <HabilitarDiagnostico />,
      allowAccessGestorSSE: false,
    },
    {
      id: "erros-envio-sas",
      label: "Atendimentos: erros envio SAS",
      component: <ErrosEnvioSas />,
      allowAccessGestorSSE: true,
    },
    {
      id: "projetos-acoes",
      label: "Atendimentos: projetos e ações",
      component: <ProjetosAcoes />,
      allowAccessGestorSSE: false,
    },
    {
      id: "anotacao-orientacao",
      label: "SSE: anotações e orientações",
      component: <AnotacaoOrientacao />,
      allowAccessGestorSSE: true,
    },
    {
      id: "blacklist-sse",
      label: "SAS: blacklist SSE",
      component: <BlacklistSSE />,
      allowAccessGestorSSE: false,
    },
    {
      id: "arquivos-anexos",
      label: "SSE: arquivos anexos",
      component: <ArquivosAnexos />,
      allowAccessGestorSSE: true,
    },
    {
      id: "versionamento-app",
      label: "Versionamento do App",
      component: <VersionamentoApp />,
      allowAccessGestorSSE: false,
    },
    {
      id: "manutencao-app",
      label: "App: serviço em manutenção",
      component: <ManutencaoApp />,
      allowAccessGestorSSE: false,
    },
    {
      id: "solicitacao-vinculo",
      label: "Empresa: solicitação de vínculo",
      component: <SolicitacaoDeVinculo />,
      allowAccessGestorSSE: false,
    },
  ];

  const [selectedOption, setSelectedOption] = useState<MenuOption | null>(null);
  const [menus, setMenus] = useState<MenuOption[]>([]);
  const { handleShowForm } = useRenderFormStore();


  useEffect(() => {
    const handleFilterMenus = async () => {
      const isAdmin = await hasAdminRole();
      const isGestorSSE = await hasGestorSSERole();
      const filteredMenus = menuOptions.filter(
          (menu) => isAdmin || (isGestorSSE && menu.allowAccessGestorSSE)
      );
      setMenus(filteredMenus);
    };
    handleFilterMenus();
    // eslint-disable-next-line
  }, []);

  const handleChangeMenu = (event: SelectChangeEvent<any>) => {
    const selectedId = event.target.value as string;
    const selectedMenu = menus.find((menu) => menu.id === selectedId) || null;
    setSelectedOption(selectedMenu);
    if (selectedMenu) {
      history.push(`/tabelas-de-controle/${selectedMenu.id}`);
    }
  };

  useEffect(() => {
    if (menus.length > 0) {
      const pathParts = location.pathname.split("/");
      const selectedId = pathParts[2];
      const selectedMenu = menus.find((menu) => menu.id === selectedId) || menus[0];

      setSelectedOption(selectedMenu);

      const isCreating = location.pathname.includes("/create");
      const isEditing = location.pathname.endsWith("/edit");
      const isCopy = location.pathname.includes("/copy");

      if (isCreating || isEditing || isCopy) {
        handleShowForm(true);
      } else {
        if (selectedMenu && selectedMenu.id !== pathParts[2]) {
          history.push(`/tabelas-de-controle/${selectedMenu.id}`);
        }
        handleShowForm(false);
      }
    }
    // eslint-disable-next-line
  }, [menus, location.pathname]);

  return (
    <React.Fragment>
      <Header>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          px={3}
          py={2}
        >
          <Grid item style={{ flexGrow: 1 }}>
            <SEText type="title">Tabelas de Controle</SEText>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          py={2}
          pr={2}
          pl={4}
        >
          <Grid item>
            <SEText type="subtitle">{selectedOption?.label}</SEText>
          </Grid>
          <Grid item>
            <CustomSelect
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedOption ? selectedOption.id : ""}
              onChange={handleChangeMenu}
              IconComponent={RiArrowDropDownLine}
            >
              {menus.map((menu) => (
                <MenuItem key={menu.id} value={menu.id}>
                  {menu.label}
                </MenuItem>
              ))}
            </CustomSelect>
          </Grid>
        </Grid>
      </Header>

      <Grid item>
        <Grid container>
          <Grid item xs={12}>
            {selectedOption?.component}
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ControlTables;
